<script context="module">
  import spark from "../assets/patterns/spark.svelte";
  import radiate from "../assets/patterns/radiate.svelte";
  import amplify from "../assets/patterns/amplify.svelte";

  export const PATTERN_NAMES = {
    spark,
    radiate,
    amplify
  };
</script>

<script>
  import { validatePropValue } from "../utilities/logs";

  /**
   * The name of the pattern to be rendered.
   * It should match one of the keys in the PATTERN_NAMES object.
   * @type {keyof typeof PATTERN_NAMES}
   */
  export let name = undefined;

  export let patternViewBox;

  /**
   * The component that will be rendered as the pattern.
   * It is determined by the `name` prop.
   * @type {SvelteComponent}
   */
  $: component = PATTERN_NAMES[name];

  validatePropValue({
    componentName: "Pattern",
    propName: "name",
    propValue: name,
    validPropValues: Object.keys(PATTERN_NAMES)
  });
</script>

<svelte:component this={component} aria-hidden="true" {patternViewBox} {...$$restProps} />
